import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


export class SkySectionedFormService {

  public requiredChange: BehaviorSubject<boolean> = new BehaviorSubject(undefined);
  public invalidChange: BehaviorSubject<boolean> = new BehaviorSubject(undefined);

  public requiredFieldChanged(required: boolean) {
    this.requiredChange.next(required);
  }

  public invalidFieldChanged(invalid: boolean) {
    this.invalidChange.next(invalid);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
